export default __webpack_public_path__ + "static/media/digitalService.9c063b1e.svg";